<div class="supervisors-container">
  <app-tabs [defaultTab]="defaultTab()" (onChangeTab)="onTabChange($event)">
    <app-manager-activities-tab />
    <app-on-field-activities-tab />
  </app-tabs>
</div>
